import React, { useEffect, useState } from 'react';
import {
  FaHospitalAlt,
  FaThumbsUp,
  FaBriefcase,
} from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import HeaderWithBack from '../../../components/HeaderWithBack';
import BottomNav from '../../../components/BottomNav';
import axios from '../../../api/axios';

interface Doctor {
  practitioner_role_id: string;
  name: string;
  specialization: string;
  years: number;
  rating: number;
  hospital: string;
  photoUrl: string;
}

const dummyDoctor: Doctor = {
  practitioner_role_id: '12345',
  name: 'dr. Fajar Sp. A',
  specialization: 'Spesialis Anak',
  years: 9,
  rating: 97,
  hospital: 'RSUD Labuang Baji',
  photoUrl: 'https://i.pravatar.cc/150?img=1',
};

const ScheduleConsultation: React.FC = () => {
  const navigate = useNavigate();
  const storedData = sessionStorage.getItem('userData');
  const userData = storedData ? JSON.parse(storedData) : null;
  const token = userData ? userData.token : null;
  const location = useLocation();

  const doctor: Doctor = location.state?.doctor ?? dummyDoctor;
  const [selectedTime, setSelectedTime] = useState<string | null>(null);

  const [availableTimes, setAvailableTimes] = useState<string[]>([]);

  useEffect(() => {
    const fetchAvailableTimes = async () => {
      try {
        const formattedDate = new Date().toISOString().slice(0, 10); // yyyy-mm-dd

        const response = await axios.get(`/check-schedule-available/${doctor.practitioner_role_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { date: formattedDate },
        });

        setAvailableTimes(response.data.time);
      } catch (error) {
        console.error('Error fetching available times:', error);
        setAvailableTimes([]);
      }
    };

    if (token && doctor?.practitioner_role_id) {
      fetchAvailableTimes();
    }
  }, [token, doctor?.practitioner_role_id]);


  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
        {/* Header */}
        <HeaderWithBack title="Pilih Jadwal" />

        {/* Foto dan Info Dokter */}
        <div className="flex justify-center mt-4">
            <div className="flex flex-col items-center text-left mb-6">
                <img
                src={doctor.photoUrl}
                alt={doctor.name}
                className="w-32 h-32 rounded-lg object-cover mb-3"
                />
                <h4 className="font-semibold text-base">{doctor.name}</h4>
                <p className="text-sm text-gray-500">{doctor.specialization}</p>

                <div className="flex gap-4 mt-2 text-sm text-gray-600">
                <span className="flex items-center gap-1">
                    <FaBriefcase className="text-teal-500" /> {doctor.years} years
                </span>
                <span className="flex items-center gap-1">
                    <FaThumbsUp className="text-teal-500" /> {doctor.rating}%
                </span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-500 mt-1">
                <FaHospitalAlt className="text-teal-500" /> {doctor.hospital}
                </div>
            </div>
        </div>

      {/* Pilih Tanggal & Waktu */}
      <div className="bg-white border rounded-xl m-6 p-4 text-center shadow-sm mb-4">
        <h4 className="font-semibold text-md mb-2"> 
          {new Date().toLocaleDateString('id-ID', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </h4>
        <p className="text-sm text-left mb-3"><strong>Pilih Waktu</strong></p>

        <div className="grid grid-cols-3 gap-2">
          {availableTimes.map((time) => (
            <button
              key={time}
              onClick={() => setSelectedTime(time)}
              className={`text-sm py-2 rounded-md border font-medium transition-all ${
                selectedTime === time
                  ? 'bg-teal-50 text-teal-700 border-teal-500'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
              }`}
            >
              {time}
            </button>
          ))}
        </div>
      </div>

      {/* Tombol Selanjutnya */}
      <div className="min-h-screen rounded-xl m-2 p-2 bg-gray-100 flex flex-col pb-28">
        <button
          disabled={!selectedTime}
          className={`w-full py-3 rounded-full font-semibold transition-all ${
            selectedTime ? 'bg-teal-500 text-white' : 'bg-gray-300 text-white'
          }`}
          onClick={() => {
            navigate(`/disclaimer/${doctor?.practitioner_role_id}`, { state: { selectedTime } });
          }}
        >
          Selanjutnya
        </button>
      </div>


      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default ScheduleConsultation;
